import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'modules',
  children: {
    item: {
      path: ':id',
    },
    promotion: {
      path: 'promotion',
    },
  },
} as const satisfies Location
